import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import TopBar from "../other-components/TopBar";
import ToastDialog from "../dialogs/ToastDialog/toast";
import { API_ACCESS_URL, getURLParam } from "../modals/Constants";
import { getStorage } from "../modals/Storage";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";

import styles from "../css/Screens.module.css";
import general from "../css/General.module.css";

function AddUSDTAddress() {
  const navigate = useNavigate();
  const toastDialogRef = useRef(null);
  const [isInputValCorrect, setInValCorrect] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const [pageConst, setConstants] = useState({
    pageTitle: "Add USDT Address",
    inUSDTAddress: "",
    inNetworkName: "",
  });

  const topBarClickAction = () => {};

  const updateLoadingStatus = (data) => {
    setShowLoading(data);
  };

  const onToastChange = () => {};

  const showToast = (message) => {
    toastDialogRef.current.openDialog(message, 2000, 500, "error");
  };

  const onInputValChange = (source, data) => {
    setConstants((prev) => {
      const updatedState = { ...prev, [source]: data };

      // Enable button when both fields are filled
      setInValCorrect(updatedState.inUSDTAddress.trim() !== "" && updatedState.inNetworkName.trim() !== "");

      return updatedState;
    });
  };

  const addUSDTAddress = () => {
    if (!isInputValCorrect) return;

    updateLoadingStatus(true);

    fetch(`${API_ACCESS_URL}?USER_ID=${getStorage("uid")}&USDT_ADDRESS=${pageConst.inUSDTAddress}&NETWORK_NAME=${pageConst.inNetworkName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Route: "route-add-usdtaddress",
        AuthToken: getStorage("secret"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        updateLoadingStatus(false);
        if (data.status_code === "success") {
          navigate(-1);
        } else {
          showToast(data.message || "Something went wrong! Please try again!");
        }
      })
      .catch(() => {
        updateLoadingStatus(false);
        showToast("There was a technical issue! Please try again!");
      });
  };

  return (
    <div className={[general.viewCenter, general.appBackground].join(" ")}>
      <div
        className={[
          general.height100vh,
          general.respWidth,
          general.overflowScrollY,
          general.appContentsBackground,
          general.hideScrollBar,
        ].join(" ")}
      >
        <TopBar intentData={pageConst} multiBtn={false} updateState={topBarClickAction} />
        <ToastDialog onToastChange={onToastChange} ref={toastDialogRef} />
        <LoadingDialog intentData={showLoading} />

        <div className={[general.zoomAnimView]}>
          <div className={[general.colView, general.mgT50px].join(" ")}>
            <div className={[styles.inputView, general.colView, general.width100].join(" ")}>
              <span className={[general.fontS13Px, general.colorLightWhite].join(" ")}>USDT Address:</span>
              <input
                type="text"
                className={[
                  general.inputBox,
                  general.height50px,
                  general.mgT10px,
                  general.borderRadius10px,
                  general.bgCustomColor6,
                ].join(" ")}
                placeholder="Enter your USDT Address"
                autoComplete="new-password"
                onChange={(e) => onInputValChange("inUSDTAddress", e.target.value)}
              />
            </div>

            <div className={[styles.inputView, general.colView, general.width100, general.mgT30px].join(" ")}>
              <span className={[general.fontS13Px, general.colorLightWhite].join(" ")}>Network Name:</span>
              <input
                type="text"
                className={[
                  general.inputBox,
                  general.height50px,
                  general.mgT10px,
                  general.borderRadius10px,
                  general.bgCustomColor6,
                ].join(" ")}
                placeholder="Enter the Network Name"
                autoComplete="new-password"
                onChange={(e) => onInputValChange("inNetworkName", e.target.value)}
              />
            </div>

            <div
              className={[
                general.height50px,
                general.width100,
                general.viewCenter,
                general.colorWhite,
                general.fontS20Px,
                general.mgT30px,
                general.borderRadius,
                isInputValCorrect ? general.bgCustomColor2 : general.bgDisable,
              ].join(" ")}
              onClick={addUSDTAddress}
              style={{ cursor: isInputValCorrect ? "pointer" : "not-allowed" }}
            >
              Save
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUSDTAddress;
